import React, { useState } from "react";
import { Button, ButtonGroup, Dropdown, Table } from "react-bootstrap";
import { Outlet } from "react-router-dom";
import AdminIcon from "../../assets/icons/Icon_Library/application icons/general/admin_alt_a.svg2";
import TrialIcon from "../../assets/icons/Icon_Library/application icons/general/admin_alt_b.svg2";
import Subheading from "../Common/Subheading";
import ControlOverview from "./ControlOverview";
import ControlOverviewModal from "./ControlOverviewModal";

export default function AdminSettings() {
  const [productType, setProductType] = useState();
  const productsTypes = [
    { value: "boomLogic", label: "boomLogic", info: "lorem" },
    { value: "Logic Workflows", label: "Logic Workflows", info: "lorem" },
    {
      value: "Broadcast & Campaign",
      label: "Broadcast & Campaign",
      info: "lorem",
    },
    { value: "boomAPI", label: "boomAPI", info: "lorem" },
    { value: "boomMail", label: "boomMail", info: "lorem" },
    {
      value: "Solutions (Range of Specific Solutions)",
      label: "Solutions (Range of Specific Solutions)",
      info: "lorem",
    },
    {
      value: "MS Messaging Connector (boomApp Connect)",
      label: "MS Messaging Connector (boomApp Connect)",
      info: "lorem",
    },
    {
      value: "Dynamics 365 Plug-In (boomApp Dynamics)",
      label: "Dynamics 365 Plug-In (boomApp Dynamics)",
      info: "lorem",
    },
    {
      value: "MS Solution Connectorser",
      label: "MS Solution Connectors",
      info: "lorem",
    },
  ];
  return (
    <>
      <div className="d-flex justify-content-between align-items-center">
        <div className="">
          <Subheading
            Icon={AdminIcon}
            heading="Admin Settings"
            subheading="All of the admin settings for your account."
          />
        </div>
        <div className=" d-flex align-items-center">
          <span className="fw-bold me-1">Products:</span>
          <span className="">
            <Dropdown as={ButtonGroup} style={{ minWidth: 180 }}>
              <Dropdown.Toggle
                className="bg-purple-gradient text-black d-flex align-items-center justify-content-between"
                id="dropdown-split-basic"
              >
                {productType ? (
                  <div className="text-start">
                    <div className="fw-bold">{productType.label}</div>
                    <div className="">{productType.info}</div>
                  </div>
                ) : (
                  "Select Product Type"
                )}
              </Dropdown.Toggle>

              <Dropdown.Menu>
                {productsTypes.map((type) => (
                  <Dropdown.Item
                    as={Button}
                    key={type.value}
                    onClick={() => setProductType(type)}
                  >
                    <div className="fw-bold">{type.label}</div>
                    <div className="text-secondary">{type.info}</div>
                  </Dropdown.Item>
                ))}
              </Dropdown.Menu>
            </Dropdown>
          </span>
        </div>
      </div>
      <Subheading
        Icon={TrialIcon}
        heading="Trial Type"
        helpKey="trial-type"
        subheading="User settings and user system controls ."
      />
      <div className="table-responsive">
        <Table striped bordered hover>
          <thead>
            <tr>
              <th>Trial Type</th>
              <th>Permissions</th>
              <th>Status</th>
              <th>Started at</th>
              <th>End at</th>
              <th>Trial origin</th>
              <th>Message credit allowance</th>
              <th>Duration</th>
              <th>Max users</th>
              <th>Access to messaging destinations</th>
              <th>Inbound numbers quantity per country</th>
              <th>Number of API connections</th>
              <th>Actions</th>
              <th>Show Details</th>
            </tr>
          </thead>
          <tbody>
            {/* Sample Data Row */}
            <tr>
              <td>Boomerang Pro</td>
              <td>View Contacts, View Messages</td>
              <td>Active</td>
              <td>15-06-2025</td>
              <td>15-07-2025</td>
              <td>Microsoft</td>
              <td>150</td>
              <td>30 mins</td>
              <td>20</td>
              <td>Local / international messaging: 50</td>
              <td>10</td>
              <td>10</td>
              <td>
                <ControlOverviewModal />
              </td>
              <td>
                <ControlOverview />
              </td>
            </tr>
            <tr>
              <td>BoomChat</td>
              <td>View Contacts</td>
              <td>Expired</td>
              <td>10-06-2025</td>
              <td>10-07-2025</td>
              <td>Google</td>
              <td>100</td>
              <td>15 mins</td>
              <td>10</td>
              <td>Local messaging: 30</td>
              <td>5</td>
              <td>5</td>
              <td>
                <ControlOverviewModal />
              </td>
              <td>
                <ControlOverview />
              </td>
            </tr>
            <tr>
              <td>MessageMax</td>
              <td>View Messages, Send Messages</td>
              <td>Active</td>
              <td>20-06-2025</td>
              <td>20-08-2025</td>
              <td>Direct</td>
              <td>200</td>
              <td>45 mins</td>
              <td>30</td>
              <td>International messaging: 70</td>
              <td>15</td>
              <td>15</td>
              <td>
                <ControlOverviewModal />
              </td>
              <td>
                <ControlOverview />
              </td>
            </tr>
            <tr>
              <td>CommsPlus</td>
              <td>View Contacts, Send Messages</td>
              <td>Active</td>
              <td>25-06-2025</td>
              <td>25-09-2025</td>
              <td>Reseller</td>
              <td>250</td>
              <td>60 mins</td>
              <td>40</td>
              <td>Local / international messaging: 80</td>
              <td>20</td>
              <td>20</td>
              <td>
                <ControlOverviewModal />
              </td>
              <td>
                <ControlOverview />
              </td>
            </tr>
          </tbody>
        </Table>
      </div>
      <Outlet />
    </>
  );
}
